// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2kkex","question":"Question_question__2QdEg","description":"Question_description__3eHsd"};